import React from 'react';
import { Router, Route, useRoute } from 'wouter';
import { useHashLocation } from 'wouter/use-hash-location';
import './App.css';

import AppTop from './AppTop.js';
import AppBottom from './AppBottom.js';
import AppTable from './AppTable.js';
import AppArticle from './AppArticle.js';
import AppAbout from './AppAbout.js';  // 修正了拼写错误 (AppAbount → AppAbout)

import AppTool from './tool/AppTool.js';

// 首页布局组件
function HomeLayout() {
  return (
    <div>
      <AppTop />
      <AppTable />
      <AppBottom />
    </div>
  );
}

// 文章页布局组件
function ArticleLayout() {
  // 获取路由参数
  const [match, params] = useRoute('/blog/article/:pid');
  
  if (!match) return null;  // 如果不是文章路由，返回null
  
  return (
    <div>
      <AppTop />
      <AppArticle pid={params.pid} />
      <AppBottom />
    </div>
  );
}

// 关于页布局组件
function AboutLayout() {
  return (
    <div>
      <AppTop />
      <AppAbout />
      <AppBottom />
    </div>
  );
}

// 工具页布局组件
function ToolLayout() {
  return (
    <div>
      <AppTop />
      <AppTool />
      <AppBottom />
    </div>
  );
}

// 主应用组件
function App() {
  return (
    <Router hook={useHashLocation}>
      {/* 首页路由 - 显示工具页面 */}
      <Route path="/" component={ToolLayout} />
      
      {/* 博客页路由 */}
      <Route path="/blog" component={HomeLayout} />
      
      {/* 文章详情页路由 */}
      <Route path="/blog/article/:pid" component={ArticleLayout} />
      
      {/* 关于页路由 */}
      <Route path="/about" component={AboutLayout} />

      {/* 工具页路由 */}
      <Route path="/tool" component={ToolLayout} />
      <Route path="/tool/:toolId" component={ToolLayout} />
    </Router>
  );
}

export default App;